export default {"src":"/_next/static/media/logo-text.ec682d74.svg","height":40,"width":400,"blurWidth":0,"blurHeight":0};